import { render, staticRenderFns } from "./LiveReports.vue?vue&type=template&id=be70a542&"
import script from "./LiveReports.vue?vue&type=script&lang=js&"
export * from "./LiveReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports